/**
 * Service requests translations (admin new request + success pages)
 */
export const serviceRequests = {
  en: {
    // Admin list page
    listTitle: "Service Requests",
    listSubtitle: "Manage client onboarding and service requests",
    drafts: "Drafts",
    submitted: "Submitted",
    underReview: "Under Review",
    approved: "Approved",
    rejected: "Rejected",
    converted: "Converted",
    searchPlaceholder: "Search by request number or company...",
    allStatus: "All Status",
    allTypes: "All Types",
    draft: "Draft",
    statusSubmitted: "Submitted",
    statusUnderReview: "Under Review",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusConverted: "Converted",
    // Service types
    discoveryStrategy: "Discovery & Strategy",
    brand: "Brand",
    productWebApps: "Product (Web & Apps)",
    digitalDesign: "Digital Design",
    digitalMarketing: "Digital Marketing",
    agencySubscription: "Agency Subscription",
    // Table
    requestNumber: "Request #",
    company: "Company",
    serviceType: "Service Type",
    progress: "Progress",
    created: "Created",
    loadingRequests: "Loading requests...",
    noRequestsFound: "No service requests found.",
    createFirstRequest: "Create Your First Request",
    viewDetails: "View Details",
    continueEditing: "Continue Editing",
    deleteRequest: "Delete Request",
    // Pagination
    previous: "Previous",
    next: "Next",
    // Delete dialog
    deleteServiceRequest: "Delete Service Request",
    deleteServiceRequestConfirm:
      "Are you sure you want to delete this service request? This action cannot be undone and all responses will be permanently lost.",
    // Detail page
    backToRequests: "Back to Requests",
    serviceRequest: "Service Request",
    requestNotFound: "Service request not found",
    completion: "Completion",
    lastUpdated: "Last Updated",
    // Status messages
    draftStatusMessage: "This request is still in draft mode.",
    submittedStatusMessage: "Request has been submitted and is awaiting review.",
    underReviewStatusMessage: "Our team is currently reviewing this request.",
    approvedStatusMessage: "This request has been approved and moved to the project backlog.",
    convertedStatusMessage: "This request is now an active project.",
    closedStatusMessage: "This request has been closed.",
    // Actions
    markUnderReview: "Mark Under Review",
    reject: "Reject",
    approveRequest: "Approve Request",
    viewInProjectBoard: "View in Project Board",
    viewCompany: "View Company",
    // AI Summary
    aiGeneratedSummary: "AI-Generated Summary",
    clientContext: "Client Context",
    summaryFromWizard: "Summary generated from wizard responses",
    summaryFromGuidance: "Information captured from the guidance chat conversation",
    reviewNotes: "Review Notes:",
    // Project details
    projectDetails: "Project Details",
    editFieldsSave: "Edit fields and save changes",
    infoFromRequest: "Information gathered from the request",
    sections: "sections",
    saved: "Saved",
    selectPlaceholder: "Select...",
    noResponsesYet: "No responses recorded yet.",
    pendingLabel: "Pending",
    noAnswerYet: "No answer yet",
    // Approve/reject dialog
    approveOrRejectTitle: "Request",
    approveConvertDesc: "This request can be converted to a project.",
    rejectSendBackDesc: "This request will be rejected and sent back for revision.",
    reviewNotesOptional: "Review Notes (Optional)",
    reviewNotesApprovePlaceholder: "Add any notes for the team...",
    reviewNotesRejectPlaceholder: "Explain what needs to be changed...",
    approveAndMoveToBacklog: "Approve & Move to Backlog",
    approveAndCreateProject: "Approve & Create Project",
    // Create Project dialog
    createProjectTitle: "Create Project",
    createProjectDesc: "Create a project from this intake request. The ticket will be linked to the new project.",
    projectName: "Project Name",
    projectNamePlaceholder: "e.g. Brand Refresh 2026",
    targetDate: "Target Date",
    hoursPurchased: "Hours Purchased",
    budgetRange: "Budget Range",
    budgetMin: "Min",
    budgetMax: "Max",
    creatingProject: "Creating...",
    createProject: "Create Project",
    projectCreated: "Project created successfully",
    viewProject: "View Project",
    // Kanban board
    draftRequest: "Draft request",
    pickedUp: "picked up",
    isOverColumn: "is over column",
    movedTo: "moved to",
    dropped: "dropped",
    dragCancelled: "drag cancelled",
    kanbanDragInstructions:
      "To pick up a request, press space or enter. While dragging, use arrow keys to move between columns. Press space or enter again to drop the request, or escape to cancel.",
    salesFunnelBoard: "Service requests sales funnel board",
    // Kanban column labels
    kanbanDraft: "Draft",
    kanbanSubmitted: "Submitted",
    kanbanInReview: "In Review",
    kanbanApproved: "Approved",
    kanbanConverted: "Converted",
    // Convert dialog
    convertTitle: "Convert Service Request",
    convertDesc: "Convert request {number} to a company project with tasks and modules.",
    convertError: "Error",
    convertErrorMsg: "Failed to load conversion preview. Please try again.",
    convertUnnamed: "Unnamed Company",
    convertResponses: "responses",
    convertCompanyHeading: "Company",
    convertLinkedCompany: "This request is already linked to an existing company.",
    convertCreateNew: "Create new company record",
    convertCompanyRequired: "Company name required",
    convertCompanyInstructions: "Enter the company/organization name below. We'll create a company record with the contact details from this request.",
    convertCompanyName: "Company Name",
    convertCompanyNamePlaceholder: "Enter company name (not contact name)",
    convertIndustry: "Industry",
    convertContactEmail: "Contact Email",
    convertBrandAssets: "Brand Assets",
    convertBrandAssetsDesc: "The following brand asset fields will be auto-populated from questionnaire responses:",
    convertMore: "more",
    convertServiceModules: "Service Modules",
    convertCreateModules: "Create service modules ({count})",
    convertTasks: "Tasks",
    convertCreateTasks: "Create tasks from templates ({count} tasks)",
    convertApproval: "Approval",
    convertEstimatedHours: "Total estimated hours:",
    convertApprovalTasks: "Tasks requiring approval:",
    convertResponsesPreserved: "{count} questionnaire responses will be preserved and linked to the company's brand profile for future reference.",
    convertConverting: "Converting...",
    convertToProject: "Convert to Project",
    // Edit page
    editRequestTitle: "Edit Request",
    backToServiceRequests: "Back to Service Requests",
    requestNotFoundTitle: "Request not found",

    // Quick Idea Dialog
    quickIdea: "Quick Idea",
    quickIdeaDesc: "Quickly capture a service idea without the full questionnaire",
    ideaTitle: "Idea Title",
    ideaTitlePlaceholder: "e.g., Redesign homepage or Launch TikTok campaign",
    ideaTitleRequired: "Title is required",
    serviceTypeRequired: "Service type is required",
    briefNotes: "Brief Notes",
    briefNotesPlaceholder: "Add any quick context or details...",
    createIdea: "Create Idea",

    // New Service Request Page (Admin)
    title: "New Service Request",
    subtitle: "Select the type of service and company to get started",
    companyTitle: "Company",
    companyDesc: "Select an existing company or leave blank for a new company",
    newCompany: "New Company",
    selectCompany: "Select a company...",
    searchCompany: "Search companies...",
    noCompaniesFound: "No companies found",
    serviceTypeTitle: "Service Type",
    serviceTypeDesc: "Choose the type of service you want to request",
    startQuestionnaire: "Start Questionnaire",
    creating: "Creating...",
    loadingCompanies: "Loading companies...",
    errorLoadingCompanies: "Error loading companies",
    // Success page
    success: {
      title: "Request Submitted Successfully",
      subtitle: "Your service request has been received",
      requestNumber: "Request Number",
      serviceType: "Service Type",
      company: "Company",
      whatHappensNext: "What happens next?",
      step1: "Our team will review your request and requirements",
      step2: "We'll reach out within 24-48 hours to discuss next steps",
      step3: "Once approved, your project will be set up and work can begin",
      viewMyRequests: "View My Requests",
      viewAllRequests: "View All Requests",
      goToDashboard: "Go to Dashboard",
      submitAnother: "Submit Another Request",
    },
  },
  es: {
    // Admin list page
    listTitle: "Solicitudes de Servicio",
    listSubtitle: "Gestiona la incorporación de clientes y solicitudes de servicio",
    drafts: "Borradores",
    submitted: "Enviadas",
    underReview: "En Revisión",
    approved: "Aprobadas",
    rejected: "Rechazadas",
    converted: "Convertidas",
    searchPlaceholder: "Buscar por número de solicitud o empresa...",
    allStatus: "Todos los Estados",
    allTypes: "Todos los Tipos",
    draft: "Borrador",
    statusSubmitted: "Enviada",
    statusUnderReview: "En Revisión",
    statusApproved: "Aprobada",
    statusRejected: "Rechazada",
    statusConverted: "Convertida",
    // Service types
    discoveryStrategy: "Descubrimiento y Estrategia",
    brand: "Marca",
    productWebApps: "Producto (Web y Apps)",
    digitalDesign: "Diseño Digital",
    digitalMarketing: "Marketing Digital",
    agencySubscription: "Suscripción de Agencia",
    // Table
    requestNumber: "Solicitud #",
    company: "Empresa",
    serviceType: "Tipo de Servicio",
    progress: "Progreso",
    created: "Creada",
    loadingRequests: "Cargando solicitudes...",
    noRequestsFound: "No se encontraron solicitudes de servicio.",
    createFirstRequest: "Crea Tu Primera Solicitud",
    viewDetails: "Ver Detalles",
    continueEditing: "Continuar Editando",
    deleteRequest: "Eliminar Solicitud",
    // Pagination
    previous: "Anterior",
    next: "Siguiente",
    // Delete dialog
    deleteServiceRequest: "Eliminar Solicitud de Servicio",
    deleteServiceRequestConfirm:
      "¿Estás seguro de que deseas eliminar esta solicitud de servicio? Esta acción no se puede deshacer y todas las respuestas se perderán permanentemente.",
    // Detail page
    backToRequests: "Volver a Solicitudes",
    serviceRequest: "Solicitud de Servicio",
    requestNotFound: "Solicitud de servicio no encontrada",
    completion: "Avance",
    lastUpdated: "Última Actualización",
    // Status messages
    draftStatusMessage: "Esta solicitud aún está en modo borrador.",
    submittedStatusMessage: "La solicitud ha sido enviada y está en espera de revisión.",
    underReviewStatusMessage: "Nuestro equipo está revisando esta solicitud actualmente.",
    approvedStatusMessage: "Esta solicitud ha sido aprobada y movida al backlog del proyecto.",
    convertedStatusMessage: "Esta solicitud es ahora un proyecto activo.",
    closedStatusMessage: "Esta solicitud ha sido cerrada.",
    // Actions
    markUnderReview: "Marcar En Revisión",
    reject: "Rechazar",
    approveRequest: "Aprobar Solicitud",
    viewInProjectBoard: "Ver en Tablero de Proyectos",
    viewCompany: "Ver Empresa",
    // AI Summary
    aiGeneratedSummary: "Resumen Generado por IA",
    clientContext: "Contexto del Cliente",
    summaryFromWizard: "Resumen generado desde respuestas del cuestionario",
    summaryFromGuidance: "Información capturada de la conversación de guía",
    reviewNotes: "Notas de Revisión:",
    // Project details
    projectDetails: "Detalles del Proyecto",
    editFieldsSave: "Edita campos y guarda cambios",
    infoFromRequest: "Información recopilada de la solicitud",
    sections: "secciones",
    saved: "Guardado",
    selectPlaceholder: "Seleccionar...",
    noResponsesYet: "Sin respuestas registradas aún.",
    pendingLabel: "Pendiente",
    noAnswerYet: "Sin respuesta aún",
    // Approve/reject dialog
    approveOrRejectTitle: "Solicitud",
    approveConvertDesc: "Esta solicitud puede convertirse en un proyecto.",
    rejectSendBackDesc: "Esta solicitud será rechazada y devuelta para revisión.",
    reviewNotesOptional: "Notas de Revisión (Opcional)",
    reviewNotesApprovePlaceholder: "Agrega notas para el equipo...",
    reviewNotesRejectPlaceholder: "Explica qué necesita ser cambiado...",
    approveAndMoveToBacklog: "Aprobar y Mover al Backlog",
    approveAndCreateProject: "Aprobar y Crear Proyecto",
    // Create Project dialog
    createProjectTitle: "Crear Proyecto",
    createProjectDesc: "Crear un proyecto a partir de esta solicitud. El ticket será vinculado al nuevo proyecto.",
    projectName: "Nombre del Proyecto",
    projectNamePlaceholder: "ej. Rediseño de Marca 2026",
    targetDate: "Fecha Objetivo",
    hoursPurchased: "Horas Compradas",
    budgetRange: "Rango de Presupuesto",
    budgetMin: "Mín",
    budgetMax: "Máx",
    creatingProject: "Creando...",
    createProject: "Crear Proyecto",
    projectCreated: "Proyecto creado exitosamente",
    viewProject: "Ver Proyecto",
    // Kanban board
    draftRequest: "Solicitud borrador",
    pickedUp: "recogida",
    isOverColumn: "está sobre la columna",
    movedTo: "movida a",
    dropped: "soltada",
    dragCancelled: "arrastre cancelado",
    kanbanDragInstructions:
      "Para recoger una solicitud, presiona espacio o enter. Mientras arrastras, usa las teclas de flecha para mover entre columnas. Presiona espacio o enter de nuevo para soltar, o escape para cancelar.",
    salesFunnelBoard: "Tablero de embudo de ventas de solicitudes de servicio",
    // Kanban column labels
    kanbanDraft: "Borrador",
    kanbanSubmitted: "Enviada",
    kanbanInReview: "En Revisión",
    kanbanApproved: "Aprobada",
    kanbanConverted: "Convertida",
    // Convert dialog
    convertTitle: "Convertir Solicitud de Servicio",
    convertDesc: "Convertir solicitud {number} a un proyecto de empresa con tareas y módulos.",
    convertError: "Error",
    convertErrorMsg: "Error al cargar la vista previa de conversión. Por favor intenta de nuevo.",
    convertUnnamed: "Empresa sin nombre",
    convertResponses: "respuestas",
    convertCompanyHeading: "Empresa",
    convertLinkedCompany: "Esta solicitud ya está vinculada a una empresa existente.",
    convertCreateNew: "Crear nuevo registro de empresa",
    convertCompanyRequired: "Nombre de empresa requerido",
    convertCompanyInstructions: "Ingresa el nombre de la empresa/organización a continuación. Crearemos un registro de empresa con los datos de contacto de esta solicitud.",
    convertCompanyName: "Nombre de la Empresa",
    convertCompanyNamePlaceholder: "Ingresa el nombre de la empresa (no el nombre de contacto)",
    convertIndustry: "Industria",
    convertContactEmail: "Email de Contacto",
    convertBrandAssets: "Activos de Marca",
    convertBrandAssetsDesc: "Los siguientes campos de activos de marca se auto-completarán con las respuestas del cuestionario:",
    convertMore: "más",
    convertServiceModules: "Módulos de Servicio",
    convertCreateModules: "Crear módulos de servicio ({count})",
    convertTasks: "Tareas",
    convertCreateTasks: "Crear tareas desde plantillas ({count} tareas)",
    convertApproval: "Aprobación",
    convertEstimatedHours: "Total de horas estimadas:",
    convertApprovalTasks: "Tareas que requieren aprobación:",
    convertResponsesPreserved: "{count} respuestas del cuestionario serán preservadas y vinculadas al perfil de marca de la empresa para referencia futura.",
    convertConverting: "Convirtiendo...",
    convertToProject: "Convertir a Proyecto",
    // Edit page
    editRequestTitle: "Editar Solicitud",
    backToServiceRequests: "Volver a Solicitudes de Servicio",
    requestNotFoundTitle: "Solicitud no encontrada",

    // Quick Idea Dialog
    quickIdea: "Idea Rápida",
    quickIdeaDesc: "Captura rápidamente una idea de servicio sin el cuestionario completo",
    ideaTitle: "Título de la Idea",
    ideaTitlePlaceholder: "ej., Rediseñar página principal o Lanzar campaña TikTok",
    ideaTitleRequired: "El título es requerido",
    serviceTypeRequired: "El tipo de servicio es requerido",
    briefNotes: "Notas Breves",
    briefNotesPlaceholder: "Agrega cualquier contexto o detalle rápido...",
    createIdea: "Crear Idea",

    title: "Nueva Solicitud de Servicio",
    subtitle: "Selecciona el tipo de servicio y empresa para comenzar",
    companyTitle: "Empresa",
    companyDesc: "Selecciona una empresa existente o deja en blanco para una nueva empresa",
    newCompany: "Nueva Empresa",
    selectCompany: "Seleccionar empresa...",
    searchCompany: "Buscar empresas...",
    noCompaniesFound: "No se encontraron empresas",
    serviceTypeTitle: "Tipo de Servicio",
    serviceTypeDesc: "Elige el tipo de servicio que deseas solicitar",
    startQuestionnaire: "Comenzar Cuestionario",
    creating: "Creando...",
    loadingCompanies: "Cargando empresas...",
    errorLoadingCompanies: "Error al cargar empresas",
    success: {
      title: "Solicitud Enviada Exitosamente",
      subtitle: "Tu solicitud de servicio ha sido recibida",
      requestNumber: "Número de Solicitud",
      serviceType: "Tipo de Servicio",
      company: "Empresa",
      whatHappensNext: "¿Qué sigue ahora?",
      step1: "Nuestro equipo revisará tu solicitud y requerimientos",
      step2: "Te contactaremos en 24-48 horas para discutir los próximos pasos",
      step3: "Una vez aprobado, tu proyecto será configurado y el trabajo podrá comenzar",
      viewMyRequests: "Ver Mis Solicitudes",
      viewAllRequests: "Ver Todas las Solicitudes",
      goToDashboard: "Ir al Panel",
      submitAnother: "Enviar Otra Solicitud",
    },
  },
};
